import { useEffect } from 'react'
import { OrganizationBreakdown, Poll } from '@/tumeloshared'
import { fetchPollsAndBallots } from '../asyncActions'
import { PollsStatusType } from '../features/polls'
import { selectPolls, selectPollsStatus } from '../features/polls/selectors'
import { isValueState, Payload } from '../payload'
import { useAppDispatch, useAppSelector } from '../store'

export const useFetchRecentPolls = (breakdown: Payload<OrganizationBreakdown>) => {
  const dispatch = useAppDispatch()
  const polls: Payload<Poll[]> = useAppSelector(selectPolls)
  const pollsStatus: Payload<PollsStatusType> = useAppSelector(selectPollsStatus)
  useEffect(() => {
    const recentPollsNotYetFetched = pollsStatus === 'not-initialised'
    if (isValueState(breakdown) && recentPollsNotYetFetched) {
      dispatch(fetchPollsAndBallots(true))
    }
  }, [breakdown, polls, pollsStatus, dispatch])
}
